import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PortalLayout from '@/components/portal/PortalLayout';
import PortalEntry from '@/components/portal/PortalEntry';
import PortalDashboard from '@/components/portal/PortalDashboard';
import PortalProfile from '@/components/portal/PortalProfile';
import PortalInductions from '@/components/portal/PortalInductions';
import PortalInductionsList from '@/components/portal/PortalInductionsList';
import PortalInviteOverview from '@/components/portal/PortalInviteOverview';
import PortalInviteSetupGuide from '@/components/portal/PortalInviteSetupGuide';
import PortalInviteDocuments from '@/components/portal/PortalInviteDocuments';
import PortalCredentials from '@/components/portal/PortalCredentials';
import PortalDigitalBadge from '@/components/portal/PortalDigitalBadge';
import PortalProjects from '@/components/portal/PortalProjects';
import PortalProjectDetail from '@/components/portal/PortalProjectDetail';
import PortalProjectDocuments from '@/components/portal/PortalProjectDocuments';
import PortalProjectTeam from '@/components/portal/PortalProjectTeam';
import PortalProjectSetupGuide from '@/components/portal/PortalProjectSetupGuide';
import PortalWelcome from '@/components/portal/PortalWelcome';

export function PortalRoutes() {
  return (
    <Routes>
      <Route path="/portal" element={<PortalLayout />}>
        <Route index element={<PortalEntry />} />
        <Route path="welcome" element={<PortalWelcome />} />
        <Route path="dashboard" element={<PortalDashboard />} />
        <Route path="profile" element={<PortalProfile />} />
        <Route path="inductions" element={<PortalInductionsList />} />
        <Route path="inductions/:submissionId" element={<PortalInviteOverview />} />
        <Route path="inductions/:submissionId/setup" element={<PortalInviteSetupGuide />} />
        <Route path="inductions/:submissionId/brief" element={<PortalInductions />} />
        <Route path="inductions/:submissionId/documents" element={<PortalInviteDocuments />} />
        <Route path="credentials" element={<PortalCredentials />} />
        <Route path="digital-badge" element={<PortalDigitalBadge />} />
        <Route path="projects" element={<Navigate to="/portal/inductions" replace />} />
        <Route path="projects/:projectId" element={<PortalProjectDetail />} />
        <Route path="projects/:projectId/documents" element={<PortalProjectDocuments />} />
        <Route path="projects/:projectId/team" element={<PortalProjectTeam />} />
        <Route path="projects/:projectId/setup" element={<PortalProjectSetupGuide />} />
      </Route>
      <Route path="/portal/*" element={<Navigate to="/portal" replace />} />
    </Routes>
  );
}
